@if( user) {
@if( user.numberOfProjects > 0) {
<!-- The navigation bar showing the Project combo on the left, button on the right -->
<form [formGroup]="form">
  <mat-toolbar color="secondary">
    <mat-toolbar-row>
      <div id="row">
        <div>
        <mat-select formControlName="project_id">
          @for (project of user.projects; track project.id) {
              <mat-option [value]="project.id">{{project.title}}</mat-option>
          }
        </mat-select>
      </div>
      <div class="flex-spacer"></div>
      @if( project ) {
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
        <mat-menu #menu="matMenu">
          <a mat-menu-item [routerLink]="['/stats', project.id, synchronizerService.currentPosition?.ref?.bookIdentifier?.toString()]">Stats  <mat-icon>bar_chart</mat-icon></a>  
          @if( project.userRole( user.user_id || '') === 'admin' ) {
            <a mat-menu-item [routerLink]="['/settings', project.id]">Settings  <mat-icon>settings</mat-icon></a>
            <a mat-menu-item [routerLink]="['/publication/pdf', project.id]">Publication  <mat-icon>publish</mat-icon></a>  
            <button mat-menu-item [matMenuTriggerFor]="advancedMenu">Advanced</button>
          }
      </mat-menu>
      <mat-menu #advancedMenu="matMenu">
        <a mat-menu-item [href]="'https://github.com/openreadersbibles/pub-'+project.id" target="_blank">GitHub  <mat-icon>code</mat-icon></a>
        <a mat-menu-item (click)="commonTasks.downloadProjectConfiguration(project)">Project JSON <mat-icon>download</mat-icon></a>
      </mat-menu>
    }

      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</form>
<!-- The editor -->
<main>
  <app-bible-navigator></app-bible-navigator>
  <app-verse-display></app-verse-display>
</main>
}
@else {
  <main class="noProjects">
  <p>Welcome to Open Reader's Bibles! It looks like you haven't started or joined any projects yet. Here are some options to get you started.</p>

  <mat-nav-list>
    <mat-list-item target="_blank" href="https://docs.openreadersbibles.org/">
      <mat-icon matListItemIcon>menu_book</mat-icon>
      <span matListItemTitle>Read the documentation...</span>
    </mat-list-item>
    <mat-list-item (click)="commonTasks.newProject()">
        <mat-icon matListItemIcon>add</mat-icon>
        <span matListItemTitle>Start a new project...</span>
    </mat-list-item>
    <mat-list-item routerLink='/join'>
      <mat-icon matListItemIcon>group_add</mat-icon>
      <span matListItemTitle>Join an existing project...</span>
    </mat-list-item>
  </mat-nav-list>
</main>
}
}
